import React, { useRef } from 'react'

import { thousandSeparator } from '../../utils/helpers'

const TopSalesCommissionTable = ({
  selectedEntity,
  handleClick
}) => {
  const divRef = useRef(null)

  return (
    <>
      <div className='flex flex-col gap-1'>
        <div className='table-header'>
          <p className='title'>Top 10 Sales Commission in { selectedEntity?.BranchName }</p>
        </div>

        <div className='border-border border rounded-[10px] shadow-md overflow-hidden flex-1 relative'>
          <div ref={ divRef } className='w-full h-full overflow-scroll hide-scrollbar bg-gray-200'>
            <div className="md:w-full w-[1080px] h-full">
              <table className="w-full border-collapse bg-white">
                <thead className="border-b border-gray-200 bg-gray-200 text-gray-one sticky top-0">
                  <tr>
                    <th scope="col" className="text-[11px] font-semibold px-1 py-2 whitespace-nowrap text-center">
                      #
                    </th>
                    <th scope="col" className="text-[11px] font-semibold p-2 whitespace-nowrap text-start">
                      Name
                    </th>
                    <th scope="col" className="text-[11px] font-semibold p-2 whitespace-nowrap text-center">
                      Branch
                    </th>
                    <th scope="col" className="text-[11px] font-semibold p-2 whitespace-nowrap text-center">
                      Subsale (RM)
                    </th>
                    <th scope="col" className="text-[11px] font-semibold p-2 whitespace-nowrap text-center">
                      Project (RM)
                    </th>
                    <th scope="col" className="text-[11px] font-semibold p-2 whitespace-nowrap text-center">
                      Commission (RM)
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {selectedEntity?.Top10List?.map((item, idx) => (
                    <tr key={ 'agentsales_' + idx } className={ "border-gray-200 text-gray-two hover:bg-gray-50" + (idx === 9 ? '' : ' border-b') }>
                      <td className="text-xs font-normal px-1 py-2 border-r whitespace-nowrap text-center">{ idx + 1 }</td>
                      <td onClick={ () => handleClick(item) } className="text-xs font-normal p-2 border-r whitespace-nowrap text-start text-primary hover:text-orange cursor-pointer">{ item.CommissionPayToUserName }</td>
                      <td className="text-xs font-normal p-2 border-r whitespace-nowrap text-center">{ item.CommissionPayToUserBranch }</td>
                      <td className="text-xs font-normal p-2 border-r whitespace-nowrap text-center">RM { thousandSeparator(item.SubsaleTotalCommission ?? 0) }</td>
                      <td className="text-xs font-normal p-2 border-r whitespace-nowrap text-center">RM { thousandSeparator(item.ProjectTotalCommission ?? 0) }</td>
                      <td className="text-xs font-normal p-2 whitespace-nowrap text-center">RM { thousandSeparator(item.TotalCommission ?? 0) }</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopSalesCommissionTable